var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.label)?_c('span',{staticClass:"om-badge",class:`om-badge-${_vm.status}`},[_vm._v(_vm._s(_vm.label))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }